import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { CheckboxComponent } from '../../../interactive-labels/checkbox/checkbox.component';
import { ButtonComponent } from '../../../buttons/button/button.component';
import { TableFilter, TableFilterOption } from '../../models/table-filter';
import { ButtonType } from '../../../enum/button-type.enum';
import { InputSize } from '../../../enum/input-size.enum';

@Component({
  selector: 'lib-checkbox-filter',
  imports: [ButtonComponent, CheckboxComponent],
  templateUrl: './checkbox-filter.component.html',
  styleUrl: './checkbox-filter.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CheckboxFilterComponent {
  tableFilter = input.required<TableFilter>();

  protected readonly ButtonType = ButtonType;
  protected readonly InputSize = InputSize;

  pillOptionsClicked(option: TableFilterOption) {
    option.isSelected?.update(value => !value);
  }

  resetClicked() {
    this.tableFilter().resetUnsavedOptions();
  }
}
